var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UnPatrolListComponent',{attrs:{"typeName":"巡回清掃 未点検一覧","type":2,"settionStrageName":"RoundUnpatrolListStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }